export interface IBankBalance {
  id: string
  bankAccountId: string
  balance: number
  recordDate: string
  clientName: string
  fileId: string | null
  ongoingReportingId: string | null
  bankAccountInfo: IBankAccount
}

export interface IBankAccount {
  id: string
  bankName: string
  bankAccountNumber: string
  accountNumberLast4?: string
  abaRoutingNumber: string
  bankAccountLink: string
  accountHolderName?: string
  isExternal: boolean
  isFunding: boolean
  purpose: string | null
  // Marked closed at the bank; a closed account never raises Plaid reconnect warnings.
  closedAt?: string | Date | null
  // Internal accounts only: the bank's number, as in "Collections 107" on IDB wires.
  collectionsAccountNumber?: number | null
  bankBalances: IBankBalance[]
  isPlaidLinked?: boolean
  currentBalance?: string | null
  isoCurrencyCode?: string | null
  plaidUpdatedAt?: string | Date | null
  plaidItemId?: string | null
  plaidLastSyncedAt?: string | Date | null
  plaidItemStatus?: string | null
  // The client must re-authenticate this connection through Plaid Link update
  // mode; derived server-side from the item status (see needsPlaidReconnect).
  plaidNeedsReconnect?: boolean
  // Connection is failing for reasons re-authenticating cannot fix (institution or
  // product-side); the next step is a fresh link, which takes the account over.
  plaidHasSyncIssue?: boolean
}

/** A Dwight collection account the borrower pays into, as listed on their payment instructions. */
export type IClientPortalInternalBankAccount = Pick<IBankAccount, 'bankName' | 'bankAccountNumber'>

/** A borrower's own bank account as their portal sees it: enough to name it and manage its Plaid link. */
export interface IClientPortalBankAccount {
  id: string
  bankName: string
  accountNumberLast4?: string | null
  isExternal: boolean
  isPlaidLinked?: boolean
  plaidItemId?: string | null
  plaidNeedsReconnect?: boolean
  plaidHasSyncIssue?: boolean
}

export enum BankAccountType {
  External = 'External',
  Internal = 'Internal',
}

export enum InternalBanks {
  IDB = 'IDB Bank',
  Webster = 'Webster Bank',
}

export const INTERNAL_BANK_TO_ROUTING = {
  [InternalBanks.IDB]: '026009768',
  [InternalBanks.Webster]: '221970443',
}
